import styled from 'styled-components';

const FlexBoxCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export { FlexBoxCenter }